export type SurveyQuestionType =
  | 'single-choice'
  | 'multi-choice'
  | 'form'
  | 'preference'
  | 'theme-select';

export interface SurveyOption {
  value: string;
  label: string;
  description?: string;
}

export interface SurveyQuestion {
  id: string;
  type: SurveyQuestionType;
  title: string;
  subtitle?: string;
  options?: SurveyOption[];
  fields?: {
    name: string;
    label: string;
    placeholder?: string;
    prefillFromUser?: 'name' | 'email';
  }[];
  sections?: {
    id: string;
    icon?: string;
    label: string;
    description: string;
    options: SurveyOption[];
  }[];
}

export const surveyQuestions: SurveyQuestion[] = [
  {
    id: 'usage',
    type: 'single-choice',
    title: 'What will you use Pique for?',
    subtitle: 'You can always change this later.',
    options: [
      { value: 'work', label: 'Work' },
      { value: 'school', label: 'School' },
      { value: 'personal', label: 'Personal' },
    ],
  },
  {
    id: 'profile',
    type: 'form',
    title: 'Tell us a bit about yourself',
    subtitle:
      "All of this is optional, but it'll help us do a better job personalizing Pique for you.",
    fields: [
      {
        name: 'firstName',
        label: 'First name',
        prefillFromUser: 'name',
      },
      {
        name: 'lastName',
        label: 'Last Name',
      },
      {
        name: 'company',
        label: 'Company or School',
      },
      {
        name: 'role',
        label: 'Your Role',
      },
    ],
  },
  // {
  //   id: 'preferences',
  //   type: 'preference',
  //   title: 'Customize your experience',
  //   subtitle:
  //     "All of this is optional, but it'll help us do a better job personalizing Pique for you.",
  //   sections: [
  //     {
  //       id: 'detail',
  //       icon: 'detail',
  //       label: 'Detail Level',
  //       description:
  //         'How much detail should Pique include in your notes by default?',
  //       options: [
  //         {
  //           value: 'concise',
  //           label: 'Concise',
  //           description: 'Just the essentials.',
  //         },
  //         {
  //           value: 'balanced',
  //           label: 'Balanced',
  //           description: 'Key points with some helpful context.',
  //         },
  //         {
  //           value: 'comprehensive',
  //           label: 'Comprehensive',
  //           description: 'Full detail and nuance.',
  //         },
  //       ],
  //     },
  //     {
  //       id: 'nudges',
  //       icon: 'nudges',
  //       label: 'Nudges',
  //       description: 'How would you like Pique to help you stay on track?',
  //       options: [
  //         {
  //           value: 'none',
  //           label: 'No nudges',
  //           description: "I'll handle follow-up myself.",
  //         },
  //         {
  //           value: 'light',
  //           label: 'Light nudges',
  //           description: "Occasional reminders for to-do's.",
  //         },
  //         {
  //           value: 'frequent',
  //           label: 'Frequent nudges',
  //           description: 'Regular prompts to stay on top of things.',
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 'note-style',
  //   type: 'single-choice',
  //   title: 'What is your ideal note style?',
  //   subtitle: "It's okay if you don't have a strong preference yet.",
  //   options: [
  //     { value: 'visual', label: 'Visual mind maps' },
  //     { value: 'outline', label: 'Clear, organized outline' },
  //     { value: 'summary', label: 'Short summary' },
  //     { value: 'detail', label: 'Full detail with context' },
  //     { value: 'mix', label: 'A mix of everything' },
  //     { value: 'unsure', label: "I'm not sure / no strong preference" },
  //   ],
  // },
  {
    id: 'display-mode',
    type: 'theme-select',
    title: 'What display mode is most comfortable for you?',
    subtitle: 'You can always change this later in settings.',
    options: [
      {
        value: 'light',
        label: 'Light',
        description: 'Classic bright interface, great for daytime use.',
      },
      {
        value: 'dark',
        label: 'Dark',
        description: 'Easy on the eyes, perfect for low-light environments.',
      },
    ],
  },
];
